declare namespace $ {

	type $mol_view__sub_bog_invest_lk_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_lk_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_open_native__files_bog_invest_lk_3 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['avatar_files'] >
		,
		ReturnType< $mol_button_open_native['files'] >
	>
	type $mol_button_open_native__accept_bog_invest_lk_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_open_native['accept'] >
	>
	type $mol_button_open_native__multiple_bog_invest_lk_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_button_open_native['multiple'] >
	>
	type $mol_button_open__sub_bog_invest_lk_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_open['sub'] >
	>
	type $mol_string_button__hint_bog_invest_lk_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string_button['hint'] >
	>
	type $mol_string_button__value_bog_invest_lk_8 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['profile_name'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_view__sub_bog_invest_lk_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_invest_lk_10 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['stat_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_lk_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_lk_12 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['persona_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_invest_lk_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_invest_lk_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_lk_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_bog_invest_lk_16 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['history_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_paragraph__title_bog_invest_lk_17 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['history_empty_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_invest_lk_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_lk_19 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['stat_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_lk_20 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['stat_value'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_lk_21 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['history_name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_invest_lk_22 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['history_details'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_invest_lk_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_invest_lk_24 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['history_turnover'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_image__uri_bog_invest_lk_25 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['avatar_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_avatar__id_bog_invest_lk_26 = $mol_type_enforce<
		ReturnType< $bog_invest_lk['player_id'] >
		,
		ReturnType< $mol_avatar['id'] >
	>
	type $mol_view__sub_bog_invest_lk_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_invest_lk_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_invest_lk extends $mol_page {
		avatar_preview( ): any
		Avatar_circle( ): $mol_view
		Avatar_label( ): $mol_paragraph
		avatar_files( next?: readonly(File)[] ): readonly(File)[]
		Avatar_native( ): $mol_button_open_native
		Avatar( ): $mol_button_open
		profile_name( next?: string ): string
		Name_input( ): $mol_string_button
		Name_row( ): $mol_view
		stat_rows( ): readonly(any)[]
		Stats( ): $mol_view
		Fun_title( ): $mol_paragraph
		persona_text( ): string
		Fun_text( ): $mol_paragraph
		Fun_card( ): $mol_view
		Card( ): $mol_view
		History_title( ): $mol_paragraph
		history_rows( ): readonly(any)[]
		History_list( ): $mol_list
		history_empty_text( ): string
		History_empty( ): $mol_paragraph
		History_section( ): $mol_view
		avatar_uri( ): string
		player_id( ): string
		stat_label( id: any): string
		Stat_label( id: any): $mol_paragraph
		stat_value( id: any): string
		Stat_value( id: any): $mol_paragraph
		history_name( id: any): string
		History_name( id: any): $mol_paragraph
		history_details( id: any): string
		History_details( id: any): $mol_paragraph
		History_info( id: any): $mol_view
		history_turnover( id: any): string
		History_turnover( id: any): $mol_paragraph
		Head( ): any
		body( ): readonly(any)[]
		Avatar_image( ): $mol_image
		Avatar_icon( ): $mol_avatar
		Stat_row( id: any): $mol_view
		History_row( id: any): $mol_view
	}
	
}

//# sourceMappingURL=lk.view.tree.d.ts.map